import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  getInquirySourceList,
  getVerticalList,
  getResponsibleUsers,
  createContact,
} from "../api/contactService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getClientSegmentByVertical } from "../../sales/inquiry/api/inquiry.api";
const getVerticalKey = (name: string) => {
  const n = name.toLowerCase();

  if (n.includes("glazing")) return "glazing";
  if (n.includes("hunter")) return "hunter_douglas";
  if (n.includes("lixil")) return "lixil";

  return "";
};
const ContactForm = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState<any>({
    name: "",
    mobile_no: "",
    inquiry_source: "",

    email: "",
    company_name: "",
    designation: "",
    address: "",
    city: "",
    state: "",
    contact_persons: [
      { name: "", mobile: "", email: "", designation: "" }
    ],
    interested_verticals: [],
    verticals: [],


  });

  const [inquirySources, setInquirySources] = useState<any[]>([]);
  const [verticals, setVerticals] = useState<any[]>([]);
  const [usersByVertical, setUsersByVertical] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState<any>({});
  /* ================= LOAD MASTER DATA ================= */
  useEffect(() => {
    loadMasters();
  }, []);

  const loadMasters = async () => {
    try {
      const sourceRes = await getInquirySourceList();
      setInquirySources(sourceRes.data?.results || []);
    } catch {
      toast.error("Failed to load inquiry sources");
    }

    try {
      const verticalRes = await getVerticalList();
      setVerticals(verticalRes.data?.results || []);
    } catch {
      console.warn("Vertical API failed (non-blocking)");
    }
  };
  const handleInterestedVerticalToggle = (verticalId: number) => {
    const exists = form.interested_verticals.includes(verticalId);

    if (exists) {
      setForm((prev: any) => ({
        ...prev,
        interested_verticals: prev.interested_verticals.filter(
          (id: number) => id !== verticalId
        ),
      }));
    } else {
      setForm((prev: any) => ({
        ...prev,
        interested_verticals: [...prev.interested_verticals, verticalId],
      }));
    }
  };
  /* ================= VERTICAL HANDLING ================= */
  const handleVerticalToggle = async (verticalId: number) => {
    const exists = form.verticals.find(
      (v: any) => v.vertical_id === verticalId
    );

    // REMOVE
    if (exists) {
      setForm({
        ...form,
        verticals: form.verticals.filter(
          (v: any) => v.vertical_id !== verticalId
        ),
      });
      return;
    }

    try {
      let users = usersByVertical[verticalId] || [];
      let segments: any[] = [];

      // ✅ Load users (only once)
      if (!usersByVertical[verticalId]) {
        const userRes = await getResponsibleUsers({
          vertical_id: verticalId,
        });

        users = userRes.data?.results || [];

        setUsersByVertical((prev: any) => ({
          ...prev,
          [verticalId]: users,
        }));
      }

      // ✅ Load segments
      const segmentRes = await getClientSegmentByVertical(verticalId);
      segments = segmentRes.data?.results || [];

      // ✅ Add vertical row
      setForm((prev: any) => ({
        ...prev,
        verticals: [
          ...prev.verticals,
          {
            vertical_id: verticalId,
            assigned_to: null,
            client_segment: null,
            segments,
          },
        ],
      }));
    } catch (err) {
      console.error(err);
      toast.error("Failed to load vertical data");
    }
  };
  const handleContactChange = (index: number, field: string, value: string) => {
    const updated = [...form.contact_persons];
    updated[index][field] = value;

    setForm({ ...form, contact_persons: updated });
  };

  const addContact = () => {
    setForm({
      ...form,
      contact_persons: [
        ...form.contact_persons,
        { name: "", mobile: "", email: "", designation: "" }
      ]
    });
  };

  const removeContact = (index: number) => {
    if (index === 0) return;

    setForm({
      ...form,
      contact_persons: form.contact_persons.filter((_: any, i: number) => i !== index)
    });
  };
  const handleAssignChange = (verticalId: number, userId: string) => {
    const updated = form.verticals.map((v: any) =>
      v.vertical_id === verticalId
        ? { ...v, assigned_to: userId }
        : v
    );

    setForm({ ...form, verticals: updated });
  };

  /* ================= VALIDATION ================= */
  const validate = () => {
    const errors: any = {};

    if (!form.name) {
      errors.name = "Contact Name is required";
    }

    if (!form.mobile_no) {
      errors.mobile_no = "Mobile is required";
    } else if (!/^[6-9]\d{9}$/.test(form.mobile_no)) {
      errors.mobile_no = "Enter valid 10-digit mobile number";
    }

    if (!form.inquiry_source) {
      errors.inquiry_source = "Source is required";
    }

    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) {
      errors.email = "Enter valid email";
    }

    // ✅ Contact persons validation
    form.contact_persons.forEach((c: any, i: number) => {

  // validate mobile only if entered
  if (c.mobile && !/^[6-9]\d{9}$/.test(c.mobile)) {
    errors[`contact_mobile_${i}`] = "Valid mobile required";
  }

  // validate email only if entered
  if (c.email && !/^\S+@\S+\.\S+$/.test(c.email)) {
    errors[`contact_email_${i}`] = "Invalid email";
  }

});

    return errors;
  };
  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
    setFieldErrors({});

    const errors = validate();

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      toast.error("Please fix highlighted fields");
      return;
    }

    try {
      setLoading(true);

      const payload: any = {
        name: form.name,
        phone: form.mobile_no,
        source: form.inquiry_source,

        email: form.email || null,
        company_name: form.company_name || null,
        designation: form.designation || null,
        address: form.address || null,
        city: form.city || null,
        state: form.state || null,

        contact_persons: form.contact_persons.map((c: any) => ({
          name: c.name,
          mobile: c.mobile,
          email: c.email || null,
          designation: c.designation
        }))
      };
      verticals.forEach((v: any) => {
        const key = getVerticalKey(v.name);

        if (!key) return;

        const isSelected = form.interested_verticals.includes(v.id);

        payload[`is_${key}`] = isSelected;
      });

      await createContact(payload);

      toast.success("Contact created successfully");
      navigate("/masters/contact");

    } catch (err) {
      console.error(err);
      toast.error("Failed to create contact");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card common-form-card p-4">
      {/* BASIC INFO */}
      <Section title="Basic Info">
        <SelectField
          label="Source*"
          options={inquirySources}
          value={form.inquiry_source}
          error={fieldErrors.inquiry_source}
          onChange={(val: any) => {
            setForm({ ...form, inquiry_source: val });

            setFieldErrors((prev: any) => {
              const updated = { ...prev };
              delete updated.inquiry_source;
              return updated;
            });
          }}
        />
        <Input
          label="Contact Name*"
          value={form.name}
          error={fieldErrors.name}
          onChange={(e: any) => {
            setForm({ ...form, name: e.target.value });

            setFieldErrors((prev: any) => {
              const updated = { ...prev };
              delete updated.name;
              return updated;
            });
          }}
        />

        <Input
          label="Mobile*"
          value={form.mobile_no}
          error={fieldErrors.mobile_no}
          onChange={(e: any) => {
            const val = e.target.value;
            if (val === "" || /^\d+$/.test(val)) {
              setForm({ ...form, mobile_no: val });

              setFieldErrors((prev: any) => {
                const updated = { ...prev };
                delete updated.mobile_no;
                return updated;
              });
            }
          }}
        />

        {/* Inquiry Source */}




      </Section>

      {/* ADDRESS */}
      <Section title="Other Details">

        <Input
          label="Email"
          value={form.email}
          error={fieldErrors.email}
          onChange={(e: any) => {
            setForm({ ...form, email: e.target.value });

            setFieldErrors((prev: any) => {
              const updated = { ...prev };
              delete updated.email;
              return updated;
            });
          }}
        />

        <Input
          label="Company Name"
          value={form.company_name}
          onChange={(e: any) =>
            setForm({ ...form, company_name: e.target.value })
          }
        />

        <Input
          label="Designation"
          value={form.designation}
          onChange={(e: any) =>
            setForm({ ...form, designation: e.target.value })
          }
        />
        <Input
          label="Address"
          value={form.address}
          onChange={(e: any) =>
            setForm({ ...form, address: e.target.value })
          }
        />

        <Input
          label="City"
          value={form.city}
          onChange={(e: any) =>
            setForm({ ...form, city: e.target.value })
          }
        />

        <Input
          label="State"
          value={form.state}
          onChange={(e: any) =>
            setForm({ ...form, state: e.target.value })
          }
        />
      </Section>
{/* 
      <div className="form-section mt-4">
        <div className="form-section-header bg-primary text-white d-flex justify-content-between align-items-center">
          <span>Contact Details</span>
          <button
            type="button"
            className="btn btn-sm btn-light"
            onClick={addContact}
          >
            Add Contact
          </button>
        </div>

        {form.contact_persons.map((contact: any, index: number) => (
          <div className="row g-3 align-items-start mb-2" key={index}>

         
            <div className="col-md-3">
              <input
                className={`form-control ${fieldErrors[`contact_name_${index}`] ? "is-invalid" : ""}`}
                placeholder="Contact Name"
                value={contact.name}
                onChange={(e) => {
                  handleContactChange(index, "name", e.target.value);

                  setFieldErrors((prev: any) => {
                    const updated = { ...prev };
                    delete updated[`contact_name_${index}`];
                    return updated;
                  });
                }}
              />
              {fieldErrors[`contact_name_${index}`] && (
                <small className="text-danger">
                  {fieldErrors[`contact_name_${index}`]}
                </small>
              )}
            </div>

         
            <div className="col-md-3">
              <input
                className={`form-control ${fieldErrors[`contact_mobile_${index}`] ? "is-invalid" : ""}`}
                placeholder="Contact Number"
                value={contact.mobile}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "" || /^\d+$/.test(val)) {
                    handleContactChange(index, "mobile", val);

                    setFieldErrors((prev: any) => {
                      const updated = { ...prev };
                      delete updated[`contact_mobile_${index}`];
                      return updated;
                    });
                  }
                }}
              />
              {fieldErrors[`contact_mobile_${index}`] && (
                <small className="text-danger">
                  {fieldErrors[`contact_mobile_${index}`]}
                </small>
              )}
            </div>

         
            <div className="col-md-3">
              <input
                className={`form-control ${fieldErrors[`contact_email_${index}`] ? "is-invalid" : ""}`}
                placeholder="Email ID"
                value={contact.email}
                onChange={(e) => {
                  handleContactChange(index, "email", e.target.value);

                  setFieldErrors((prev: any) => {
                    const updated = { ...prev };
                    delete updated[`contact_email_${index}`];
                    return updated;
                  });
                }}
              />
              {fieldErrors[`contact_email_${index}`] && (
                <small className="text-danger">
                  {fieldErrors[`contact_email_${index}`]}
                </small>
              )}
            </div>

        
            <div className="col-md-2">
              <input
                className={`form-control ${fieldErrors[`contact_designation_${index}`] ? "is-invalid" : ""}`}
                placeholder="Designation"
                value={contact.designation}
                onChange={(e) => {
                  handleContactChange(index, "designation", e.target.value);

                  setFieldErrors((prev: any) => {
                    const updated = { ...prev };
                    delete updated[`contact_designation_${index}`];
                    return updated;
                  });
                }}
              />
              {fieldErrors[`contact_designation_${index}`] && (
                <small className="text-danger">
                  {fieldErrors[`contact_designation_${index}`]}
                </small>
              )}
            </div>

        
            <div className="col-md-1 text-end">
              {index !== 0 && (
                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => removeContact(index)}
                >
                  ✕
                </button>
              )}
            </div>

          </div>
        ))}
      </div> */}
      <Section title="Vertical(s)">
        <div className="row">
          {verticals.map((v: any) => (
            <div className="col-md-3 mb-2" key={v.id}>
              <label className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  checked={form.interested_verticals.includes(v.id)}
                  onChange={() => handleInterestedVerticalToggle(v.id)}
                />
                {v.name}
              </label>
            </div>
          ))}
        </div>
      </Section>

      {/* VERTICALS */}
      {/* <Section title="Vertical Details">
        <div className="row fw-bold mb-2">
          <div className="col-md-4">Vertical</div>
          <div className="col-md-4">Client Segment</div>
          <div className="col-md-4">Assigned To*</div>
        </div>

        {verticals.map((v: any) => {
          const selected = form.verticals.find(
            (x: any) => x.vertical_id === v.id
          );

          return (
            <div className="row align-items-center mb-2" key={v.id}>

         
              <div className="col-md-4">
                <input
                  type="checkbox"
                  checked={!!selected}
                  onChange={() => handleVerticalToggle(v.id)}
                />{" "}
                {v.name}
              </div>

          
              <div className="col-md-4">
                <Select
                  isDisabled={!selected}
                  placeholder="Select Segment"
                  options={(selected?.segments || []).map((s: any) => ({
                    value: s.id,
                    label: s.name,
                  }))}
                  value={(selected?.segments || [])
                    .map((s: any) => ({
                      value: s.id,
                      label: s.name,
                    }))
                    .find((opt: any) => opt.value === selected?.client_segment)}
                  onChange={(opt: any) => {
                    setForm((prev: any) => ({
                      ...prev,
                      verticals: prev.verticals.map((vItem: any) =>
                        vItem.vertical_id === v.id
                          ? { ...vItem, client_segment: opt?.value }
                          : vItem
                      ),
                    }));
                  }}
                />
              </div>


              <div className="col-md-4">
                <select
                  className="form-control"
                  disabled={!selected}
                  value={selected?.assigned_to || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    setForm((prev: any) => ({
                      ...prev,
                      verticals: prev.verticals.map((vItem: any) =>
                        vItem.vertical_id === v.id
                          ? { ...vItem, assigned_to: value }
                          : vItem
                      ),
                    }));
                  }}
                >
                  <option value="">Select User</option>

                  {(usersByVertical[v.id] || []).map((u: any) => (
                    <option key={u.id} value={u.id}>
                      {u.name || u.username}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          );
        })}
      </Section> */}

      {/* SUBMIT */}
      <div className="d-flex justify-content-end mt-3">
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Contact"}
        </button>
      </div>
    </div>
  );
};

export default ContactForm;

/* ================= REUSABLE ================= */

const Section = ({ title, children }: any) => (
  <div className="form-section">
    <div className="form-section-header bg-primary text-white">
      {title}
    </div>
    <div className="row g-3 p-3">{children}</div>
  </div>
);

const Input = ({ label, error, ...props }: any) => (
  <div className="col-md-4">
    <label className="form-label">{label}</label>
    <input
      className={`form-control ${error ? "is-invalid" : ""}`}
      {...props}
    />
    {error && <small className="text-danger">{error}</small>}
  </div>
);

/* ================= SELECT FIELD ================= */
const SelectField = ({ label, options, value, onChange, error }: any) => {
  const mappedOptions = (options || []).map((o: any) => ({
    value: o.id,
    label: o.name,
  }));

  const selectedOption = mappedOptions.find(
    (opt: any) => String(opt.value) === String(value)
  );

  return (
    <div className="col-md-4">
      <label className="form-label">{label}</label>
      <Select
        styles={{
          control: (base) => ({
            ...base,
            borderColor: error ? "red" : base.borderColor,
          }),
        }}
        options={mappedOptions}
        value={selectedOption || null}
        onChange={(selected: any) => onChange(selected?.value)}
        placeholder={`Select ${label}`}
        isClearable
      />
      {error && <small className="text-danger">{error}</small>}
    </div>
  );
};